// src/features/records/components/MapView/components/MapSkeleton.js
import styles from './MapSkeleton.module.css';

const MapSkeleton = () => {
  return (
    <div className={styles.skeleton}>
      {/* Map area skeleton */}
      <div className={styles.mapArea}>
        <div className={styles.shimmer}></div>
      </div>
      
      {/* Controls skeleton */}
      <div className={styles.controls}>
        <div className={styles.controlButton}></div>
        <div className={styles.controlButton}></div>
      </div>
      
      {/* Attribution skeleton */}
      <div className={styles.attribution}>
        <div className={styles.attributionText}></div>
      </div>
    </div>
  );
};

export default MapSkeleton;